import { effect, inject, Injectable, Injector, runInInjectionContext } from '@angular/core'
import { pDefer } from '@naturalcycles/js-lib'
import { SignalStore } from '@src/app/core/store/signalStore.js'
import { MixpanelEvent } from '@src/app/shared/typings/analytics.js'
import { ModalInterface } from '@src/app/shared/typings/interfaces/modals.js'
import { MixpanelService } from './analytics/mixpanel.service.js'

@Injectable({ providedIn: 'root' })
export class ModalService {
  private store = inject(SignalStore)
  private injector: Injector = inject(Injector)
  private mixpanelService = inject(MixpanelService)

  async show(modal: ModalInterface): Promise<void> {
    const promise = pDefer<void>()
    const current = this.store.$modals()
    if (current.some(m => m.modalName === modal.modalName)) return
    this.store.$modals.update(current => [...current, modal])
    if (modal.modalName) {
      void this.mixpanelService.trackEvent(MixpanelEvent.ViewedModal, {
        name: modal.modalName,
      })
    }

    runInInjectionContext(this.injector, () => {
      effect(() => {
        if (!this.store.$modals().some(m => m.modalName === modal.modalName)) {
          promise.resolve()
        }
      })
    })

    await promise
  }

  remove(): void {
    this.store.$modals.update(current => current.slice(0, -1))
  }
}
